<template>
    <div class="reum-fileuploader">
        <input ref="nfile" type="file" v-show="file.filename==''" @change="file.onFileSelected" :accept="file.accept" :title="file.title">
        <div v-show="file.filename!=''">
            <span class="file-name" @click="file.download">{{file.filename}}</span> &nbsp;
            <button class="btn-delete" @click="file.onFileDelete()">삭제</button>
        </div>
    </div>
</template>

<script>
import { onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { useToast } from 'vue-toastification';
import axios from 'axios';

export default {
    name: 'CarrotUploader',
    components: {
    },
    props: {
        accept : {
            type: String,
            default : "*"
        },
        maxsize: {
            type: [Number, String],
            default: 50,
        },
        filename : {
            type: String,
            default: "",
        },
        url : {
            type: String,
            default: "",
        },
        title : {
            type: String,
            default: "",
        }
    },
    emits: [ 'update:filename', 'update:url', 'change' ],
    setup(props, {emit}) {
        const nfile = ref(null);
        const toast  = useToast();
        
        const file = reactive({
            maxsize : 50,
            filename: "",
            filedata: null,
            accept: "*",
            title: "",
            download : () => {
                // location.href=file.filedata;
                fetch(file.filedata)
                    .then(response => response.blob())
                    .then(blob => {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = file.filename;
                    link.click();
                })
                .catch(console.error);

            },
            onFileSelected: (f) => {
                if(f.target.files.length == 1) {
                    if( f.target.files[0].size > file.maxsize*1024*1024 ) {
                        toast.error("50메가 이상의 파일은 업로드 하실 수 없습니다.");
                        file.filename = '';
                        file.filedata = null;
                        nfile.value.value="";
                        return;
                    }
                    let formData = new FormData();
                    formData.append("nfile", f.target.files[0]);
                    formData.append("path", "");

                    axios.post('/ai/fileUpload', formData, {
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    }).then((res) => {
                        file.filename = res.data.filename;
                        file.filedata = res.data.url;
                        emit( 'update:filename', res.data.filename);
                        emit( 'update:url', res.data.url);
                    });


                }
            },
            onFileDelete: () => {
                file.filename = '';
                file.filedata = null;
                nfile.value.value="";
                emit( 'update:filename', '');
                emit( 'update:url', '');
            }
        });
        
        watch(() => props.filename, (nVal, oVal) => {
            if(nVal != oVal) {
                file.filename = props.filename;
            }
        });

        watch(() => props.url, (nVal, oVal) => {
            if(nVal != oVal) {
                file.filedata = props.url;
            }
        });


        onMounted(() => {
            // Mounted
            file.maxsize = props.maxsize?Number(props.maxsize):50;
            // console.info(props.filename);
            if(props.filename!="") {
                file.filename = props.filename;
            }
            if(props.url!="") {
                file.filedata = props.url;
            }
            file.accept = props.accept;
            file.title = props.title;
        });

        onUnmounted(() => { 
            // UnMounted
        });
        return {file, nfile};
    }

}
</script>
<style lang="scss" scoped>
.file-name {
    cursor: pointer;
}
.btn-delete {
    background-color: #fff;
    border: 1px solid #333;
    border-radius: 3px;
    &:hover {
        background-color: rgb(175, 17, 17);
        color: #FFF;
    }
}
</style>